
/**
 * 合格ダイアリー - 実績レポート画面 - 年間グラフ
 */
import {
  SelectedLabelItem,
  isLabelChecked,
  getColor,
} from '@/components/views/PassDiary/Common'
import { computed, defineComponent, PropType, ref, watch, onMounted } from 'vue'
import { UserScheduleSummary } from '@/typings/PassDiary'

const CANVAS_WIDTH: number = 375

export default defineComponent({
  name: 'YearReportGraph',
  props: {
    userScheduleSummary: {
      type: Array as PropType<UserScheduleSummary[]>,
      required: true,
    },
    selectedItemArray: {
      type: Array as PropType<SelectedLabelItem[]>,
      required: true,
    },
    yearReportGraphHeight: {
      type: Number,
      required: true,
    },
    targetDate: {
      type: Date,
      required: true,
    },
  },

  setup(props) {
    onMounted(() => {
      paintReportGraph()
    })

    watch<SelectedLabelItem[]>(
      () => props.selectedItemArray,

      () => paintReportGraph()
    )
    watch<UserScheduleSummary[]>(
      () => props.userScheduleSummary,

      () => paintReportGraph()
    )
    const paintReportGraph = (): void => {
      resetCanvas()
      const context = barGraphContext.value

      if (!context) {
        return
      }
      //canvas background
      context.fillStyle = '#ececec'
      context.fillRect(0, 0, 375, props.yearReportGraphHeight)
      //graph background
      context.fillStyle = '#ffffff'
      context.fillRect(60, 0, 315, props.yearReportGraphHeight - 68)
      //縦目盛
      context.fillStyle = 'rgba(0,0,0,0.5)'
      context.font = '400 16px Noto Sans JP'
      context.textAlign = 'center'
      context.textBaseline = 'middle'
      context.strokeStyle = 'rgba(0,0,0,0.5)'
      context.lineWidth = 1

      let rectH = 0
      const gradationsCount = (props.yearReportGraphHeight - 84) / 72
      for (var i = 0; i < gradationsCount; i++) {
        context.beginPath()
        context.fillText(gradationsCount - i + '00h', 36, 16 + 72 * i)
        context.moveTo(60, 16 + 72 * i)
        context.lineTo(65, 16 + 72 * i)
        context.stroke()
      }

      //横目盛
      let d = ''
      let w = ''
      context.font = '400 12px Noto Sans JP'
      let month = 0
      for (var k = 0; k < 12; k++) {
        context.beginPath()
        month =
          new Date(
            props.targetDate.getFullYear(),
            props.targetDate.getMonth() - 11 + k,
            1
          ).getMonth() + 1
        context.fillText(
          month + '',
          85 + k * 24,
          props.yearReportGraphHeight - 48
        )
      }
      //週間サマリー

      for (var h = 0; h < 12; h++) {
        if (!props.userScheduleSummary[h]) {
          break
        }

        var dataArr = props.userScheduleSummary[h].actual
        const monthlyGraphWidth = 10
        let monthlyGraphHeight = 0
        let monthlyGraphEnd = props.yearReportGraphHeight - 68
        let idx = 0
        for (var j = 0; j < dataArr.length; j++) {
          idx = dataArr.length - j - 1
          if (isLabelChecked(dataArr[idx].label, props.selectedItemArray)) {
            context.fillStyle = `${
              getColor(dataArr[idx].label, props.selectedItemArray).achieveColor
            }`
            monthlyGraphHeight = Math.ceil(dataArr[idx].value * 0.012)
            context.fillRect(
              80 + h * 24,
              monthlyGraphEnd - monthlyGraphHeight,
              monthlyGraphWidth,
              monthlyGraphHeight
            )
            monthlyGraphEnd = monthlyGraphEnd - monthlyGraphHeight
          }
        }
      }
    }

    const barGraphCanvas = ref<HTMLCanvasElement>()

    const barGraphContext = computed<
      CanvasRenderingContext2D | null | undefined
    >(() => barGraphCanvas.value?.getContext('2d'))

    const resetCanvas = (): void => {
      if (!barGraphContext.value) {
        return
      }
      barGraphContext.value.clearRect(
        0,
        0,
        CANVAS_WIDTH,
        props.yearReportGraphHeight
      )
    }

    return {
      CANVAS_WIDTH,
      barGraphCanvas,
    }
  },
})
